export enum CareconneCompanyEnum {
  usePlanCk = 1,
  usePlanNotCk = 2
}
